import axios from "axios";
import React, { useEffect, useState } from "react";
// import "./Register.css";
import logo1024 from "../../../assets/logo1024.png";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/loader/Loader";
import { ToastContainer, toast } from "react-toastify";
// import "react-/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";

import CustomButton from "../../../Components/New_Components/CustomButton";
import CustomInput from "../../../Components/New_Components/CustomInput";

function Register() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024); // lg breakpoint (1024px)
    };

    handleResize(); // check on mount
    window.addEventListener("resize", handleResize); // update on resize

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const notify = (message) => toast(message);
  const [theme, setTheme] = useState(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  );
  // console.log("--------------------------running");

  const validate = () => {
    setLoading(true);
    console.log("------------Validating");
    let errorMessage = {};
    errorMessage.firstName =
      firstName.length !== 0 ? "" : "Please enter required fields !!!";
    errorMessage.lastName =
      lastName.length !== 0 ? "" : "Please enter required fields !!!";
    errorMessage.password =
      password.length !== 0
        ? checkPassword(password)
          ? ""
          : "Password must at least 8 characters and contain both numbers and letter/special characters."
        : "Please enter required fields !!!";
    errorMessage.email =
      email.length !== 0
        ? checkEmail(email)
          ? ""
          : "Invalid Email !!!"
        : "Please enter required fields !!!";
    errorMessage.mobileNumber =
      mobileNumber.length !== 0
        ? checkPhone(mobileNumber)
          ? ""
          : "Invalid Phone Number !!!"
        : "Please enter required fields !!!";
    errorMessage.confirmPassword =
      password.length !== 0
        ? matchPassword(password, confirmPassword)
          ? ""
          : "Password does not match !!!"
        : "Please enter required fields !!!";
    setErrors({ ...errorMessage });
    setLoading(false);
    return Object.values(errorMessage).every((newData) => newData === "");
  };

  const checkEmail = (email) => {
    const regEmail = /^\w+([\.-]?\w+)@\w+([.-]?\w+)(\.\w{2,3})+$/;
    if (regEmail.test(email) === false) {
      return false;
    } else {
      return true;
    }
  };

  const checkPassword = (password) => {
    const regPassword =
      /^(?=.*\d)(?=.*[!@#$%^&*_+()<>,./:";'{}])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (regPassword.test(password) === false) {
      return false;
    } else {
      return true;
    }
  };

  const checkPhone = (mobileNumber) => {
    if (mobileNumber.length !== 10) {
      return false;
    } else {
      return true;
    }
  };

  const matchPassword = (password, confirmPassword) => {
    if (confirmPassword === password) {
      return true;
    } else {
      setConfirmPassword("");
      setPassword("");
      return false;
    }
  };
  const handleFirstName = (event) => {
    setFirstName(event.target.value);
  };
  const handleLastName = (event) => {
    setLastName(event.target.value);
  };
  const handleEmail = (event) => {
    setEmail(event.target.value);
  };
  const handleMobileNumber = (event) => {
    setMobileNumber(event.target.value);
  };
  const handlePassword = (event) => {
    setPassword(event.target.value);
  };
  const handleConfirmPassword = (event) => {
    setConfirmPassword(event.target.value);
  };

  const Register = async () => {
    setLoading(true);
    try {
      const proxyUrl =
        "/api/registerUser" +
        "?firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&phone=" +
        mobileNumber +
        "&email=" +
        email +
        "&password=" +
        password;
      setLoading(true);

      axios
        .post(proxyUrl, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          console.log(response.data);
          setLoading(false);
          notify("Congratulations, signed up successfully.", {
            type: "success",
            theme: theme === "dark" ? "light" : "dark",
          });
          navigate("/loginwithotp");
        })
        .catch((error) => {
          setLoading(false);
          notify("Check credentials or try again later", {
            type: "error",
            theme: theme === "dark" ? "light" : "dark",
          });
          console.error(error); // handle any errors here
        });
    } catch (error) {
      setLoading(false);
      notify("Check credentials or try again later", {
        type: "error",
        theme: theme === "dark" ? "light" : "dark",
      });
      console.log(error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (validate()) {
      Register();
    }
  };
  return (
    <div className="lg:min-h-screen bg-[#FFFFFF]  w-full flex flex-col justify-center font-roboto">
      {/* <div className="sm:mx-auto sm:w-full w-[20%] sm:max-w-md"> */}
      {/* <div className="w-[90%] lg:w-[35%] mx-auto rounded-lg"> */}
      <div
        className="lg:py-4 lg:px-8 lg:w-[35%] mx-auto rounded-2xl sm:px-10 "
        style={{
          backgroundImage: isLargeScreen
            ? `url(${require("../../../assets/border_line1.png")})`
            : "none",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="lg:px-3 lg:py-2 py-10 px-4">
          <h2 className="text-left text-3xl font-bold lg:mt-4 lg:mb-2 my-4 text-black">
            Register Now
          </h2>
          <form className="mb-0 space-y-2" onSubmit={handleSubmit}>
            <div className="flex flex-row gap-[3.9rem] w-[100%] ">
              <div>
                <label htmlFor="firstName" className="block  text-gray-700">
                  First Name
                </label>
                <CustomInput
                  placeholder={"John"}
                  type="text"
                  id={"firstName"}
                  required={true}
                  value={firstName}
                  onChange={handleFirstName}
                  widthPercentage={100}
                />
                {errors.firstName && (
                  <div className="error"> {errors.firstName} </div>
                )}
              </div>

              <div>
                <label htmlFor="lastName" className="block  text-gray-700">
                  Last Name
                </label>
                <CustomInput
                  placeholder={"xyz"}
                  type="text"
                  id={"lastName"}
                  required={true}
                  value={lastName}
                  onChange={handleLastName}
                  widthPercentage={100}
                />
                {errors.lastName && (
                  <div className="error"> {errors.lastName} </div>
                )}
              </div>
            </div>
            <div>
              <label htmlFor="phoneNumber" className="block  text-gray-700 ">
                Phone Number
              </label>
              <CustomInput
                placeholder={"Enter your phone number"}
                type="tel"
                id={"lastName"}
                maxLength={10}
                required={true}
                value={mobileNumber}
                onChange={handleMobileNumber}
              />
              {errors.phoneNumber && (
                <div className="error"> {errors.phoneNumber} </div>
              )}
            </div>

            <div>
              <label htmlFor="email" className="block text-gray-700">
                E-mail
              </label>
              <CustomInput
                placeholder={"Enter your mail"}
                type="email"
                id={"email"}
                required={true}
                value={email}
                onChange={handleEmail}
              />
              {errors.email && <div className="error"> {errors.email} </div>}
            </div>

            <div>
              <label htmlFor="password" className="block text-gray-700">
                Password
              </label>
              <CustomInput
                placeholder={"Enter password"}
                type="password"
                id={"password"}
                required={true}
                value={password}
                onChange={handlePassword}
                showToggle={true}
              />
              {errors.password && (
                <div className="error"> {errors.password} </div>
              )}
            </div>

            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-sm text-gray-700"
              >
                Confirm Password
              </label>
              <CustomInput
                placeholder={"Confirm password"}
                type="password"
                id={"confirmPassword"}
                required={true}
                value={confirmPassword}
                onChange={handleConfirmPassword}
                showToggle={true}
              />
              {errors.confirmPassword && (
                <div className="error"> {errors.confirmPassword} </div>
              )}
            </div>

            <div className="w-full">
              <CustomButton
                disabled={loading}
                filledColor="#000000"
                borderColor="#fff"
                textColor="#fff"
                title={loading ? <Loader /> : "Sign Up"}
              />
            </div>
          </form>

          <div className="text-center mt-6">
            <p className="text-sm text-gray-600">
              Already have an account?{" "}
              <a
                href="/login"
                className="font-medium text-[#007AFF] hover:text-blue-500 no-underline"
              >
                Login
              </a>
            </p>
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>

    // <div
    //   className={
    //     theme === "dark" ? "containerRegisterDark" : "containerRegister"
    //   }
    // >
    //   <ToastContainer />
    //   <form
    //     className={theme === "dark" ? "formDark" : "form"}
    //     onSubmit={handleSubmit}
    //   >
    //     <div className="imgDiv">
    //       <img className="imgSty" src={logo1024} alt="Logo" />
    //     </div>
    //     <div className="field nameField">
    //       <div>
    //         <label className={theme === "dark" ? "labelDark" : "label"}>
    //           First Name
    //         </label>
    //         <input
    //           type="text"
    //           className="firstNameInput"
    //           value={firstName}
    //           placeholder="Enter First Name"
    //           onChange={handleFirstName}
    //           required
    //         />
    //         {errors.firstName && (
    //           <div className="error"> {errors.firstName} </div>
    //         )}
    //       </div>
    //       <div>
    //         <label className={theme === "dark" ? "labelDark" : "label"}>
    //           Last Name
    //         </label>
    //         <input
    //           type="text"
    //           className="lastNameInput"
    //           value={lastName}
    //           placeholder="Enter last Name"
    //           onChange={handleLastName}
    //         />
    //         {errors.lastName && (
    //           <div className="error"> {errors.lastName} </div>
    //         )}
    //       </div>
    //     </div>

    //     <div className="field">
    //       <label className={theme === "dark" ? "labelDark" : "label"}>
    //         Email
    //       </label>
    //       <input
    //         type="email"
    //         value={email}
    //         placeholder="Enter email"
    //         onChange={handleEmail}
    //         required
    //       />
    //       {errors.email && <div className="error"> {errors.email} </div>}
    //     </div>
    //     <div className="field">
    //       <label className={theme === "dark" ? "labelDark" : "label"}>
    //         Phone Number
    //       </label>
    //       <input
    //         type="tel"
    //         value={mobileNumber}
    //         placeholder="Enter Phone"
    //         maxLength={10}
    //         minLength={10}
    //         onChange={handleMobileNumber}
    //         required
    //       />
    //       {errors.phoneNumber && (
    //         <div className="error"> {errors.phoneNumber} </div>
    //       )}
    //     </div>
    //     <div className="field">
    //       <label className={theme === "dark" ? "labelDark" : "label"}>
    //         New Password
    //       </label>
    //       <input
    //         type="password"
    //         value={password}
    //         placeholder="Password"
    //         onChange={handlePassword}
    //         required
    //       />
    //       {errors.password && <div className="error"> {errors.password} </div>}
    //     </div>
    //     <div className="field">
    //       <label className={theme === "dark" ? "labelDark" : "label"}>
    //         Confirm Password
    //       </label>
    //       <input
    //         type="password"
    //         value={confirmPassword}
    //         placeholder="Confirm Password"
    //         onChange={handleConfirmPassword}
    //         required
    //       />
    //       {errors.confirmPassword && (
    //         <div className="error"> {errors.confirmPassword} </div>
    //       )}
    //     </div>
    //     <button className="button" type="submit" disabled={loading}>
    //       {loading ? <Loader /> : "Sign Up"}
    //     </button>
    //   </form>
    // </div>
  );
}
export default Register;
